import { render, staticRenderFns } from "./Simplify.vue?vue&type=template&id=276eefd8&scoped=true&"
import script from "./Simplify.vue?vue&type=script&lang=js&"
export * from "./Simplify.vue?vue&type=script&lang=js&"
import style0 from "./Simplify.vue?vue&type=style&index=0&id=276eefd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276eefd8",
  null
  
)

export default component.exports